
let labels = {
  engagement: "Engagement",
  mentions: "Total Posts",
  likes_count: "Total Likes",
  views_count: "Total Views",
  comments_count: "Total Comments",
  shares_count: "Total Shares",
}

function logarithmicChartLayout(labelkey, chartScale) {
  if (chartScale == "logarithmic") {
    return {field: "y", type: "quantitative", title: labels[labelkey], scale: {type: "log"}, stack: false }
  } else {
    return {field: "y", type: "quantitative", title: labels[labelkey] }
  }
}

function showLayerForMultiTooltipData(labelkey, ajaxResponseData, chartLayout, hidePoint, colorHash, chartScale, legendTitle) {
  // Apply legendTitle if provided to control the legend title explicitly
  if (legendTitle) {
    // Prefer legend.title for Vega-Lite; remove top-level title to avoid conflicts
    if (colorHash && colorHash.title) { delete colorHash.title }
    colorHash.legend = Object.assign({}, colorHash.legend, { title: legendTitle })
  }
  // Build calculate transforms to replace undefined values with 0 for tooltip usage
  const categories = uniqueCategories(ajaxResponseData)
  const calculateTransforms = categories.map((name) => {
    // Escape single quotes and backslashes for field references in Vega-Lite expressions
    const safeName = `${name}`.replace(/\\/g, "\\\\").replace(/'/g, "\\'");
    // Create a sanitized field name for tooltip usage - remove problematic characters
    const safeFieldName = `${name}`.replace(/[^a-zA-Z0-9_]/g, '_') + '_safe';
    return { calculate: `isValid(datum['${safeName}']) ? datum['${safeName}'] : 0`, as: safeFieldName };
  });
  return [
    { 
      encoding: {color: colorHash, y: logarithmicChartLayout(labelkey, chartScale)},
      layer: [changeChartLayout(chartLayout), hidePoints(hidePoint)]
    },
    {
      transform: [
        {pivot: "c", value: "y", groupby: ["x"]},
        ...calculateTransforms
      ],
      mark: "rule",
      encoding: {opacity: {condition: {value: 0.3, param: "hover", empty: false}, value: 0}, tooltip:
        tooltipdata(ajaxResponseData)
      },
      params: [{
        name: "hover",
        select: {
          type: "point",
          fields: ["x"],
          nearest: true,
          on: "mouseover",
          clear: "mouseout"
        }
      }]
    }
  ]
}

function tooltipdata(ajaxResponseData){
  let tooltipDataArray = []
  for (var i = 0; i < ajaxResponseData.length; i++) {
    tooltipDataArray.push({field: "x", "type": "temporal", title: "Time", format: "%b %d, %Y %H:%M" })
    // Create sanitized field name to match what was created in calculateTransforms
    const sanitizedFieldName = `${ajaxResponseData[i]["c"]}`.replace(/[^a-zA-Z0-9_]/g, '_') + '_safe';
    tooltipDataArray.push({
      field: sanitizedFieldName, 
      "type": "quantitative", 
      format: ".2~s",
      title: ajaxResponseData[i]["c"]
    })
  }
  return tooltipDataArray
};

function hidePoints(hidePoint) {
  if (hidePoint == true || window.location.search.includes("hide_points=true")) {
    return {transform: [{filter: {param: "hover", empty: true}}], mark: "point" }
  } else {
    return {transform: [{filter: {param: "hover", empty: false}}], mark: "point" }
  }
}

function changeChartLayout(chartLayout) {
  if (chartLayout == 'bar' || window.location.search.includes("bar")) {
    return {mark: {type: "bar", width: {band: 0.92}}}
  } else if (chartLayout == "area" || window.location.search.includes("area")) {
    return {mark: "area"}
  } else {
    return {mark: "line"}
  }
}

function getPointData(spec, view) {
  var prevPoint, nextPoint, fromDate, fromDateString, toDate, toDateString = ''
  view.addEventListener('dblclick', function (event, item) {
    for (var i = 0; i < item.mark.items.length; i++) {
      if (item.mark.items[i].tooltip == item.tooltip) {
        prevPoint = item.mark.items[i-1]?.tooltip
        nextPoint = item.mark.items[i+1]?.tooltip
      }
    }
    if (prevPoint && nextPoint) {
      fromDate = new Date(prevPoint.Time).toISOString()
      fromDateString = fromDate.substr(0,16)
      toDate = new Date(nextPoint.Time).toISOString()
      toDateString = toDate.substr(0,16)
      window.open(`${window.location.origin}/monitoring?published_at_from=${fromDateString}&published_at_to=${toDateString}`, "_blank")
    } else if ( prevPoint && nextPoint == undefined) {
      fromDate = new Date(prevPoint.Time).toISOString()
      fromDateString = fromDate.substr(0,16)
      toDate = new Date(item.datum.datum.x).toISOString()
      toDateString = toDate.substr(0,16)
      window.open(`${window.location.origin}/monitoring?published_at_from=${fromDateString}&published_at_to=${toDateString}`, "_blank")
    } else if (prevPoint == undefined && nextPoint) {
      fromDate = new Date(item.datum.datum.x).toISOString()
      fromDateString = fromDate.substr(0,16)
      toDate = new Date(nextPoint.Time).toISOString()
      toDateString = toDate.substr(0,16)
      window.open(`${window.location.origin}/monitoring?published_at_from=${fromDateString}&published_at_to=${toDateString}`, "_blank")
    }
  })
}

function uniqueCategories(ajaxResponseData){
  const uniqueCategories = new Set();
  
  ajaxResponseData.forEach(item => {
    if (item.c) uniqueCategories.add(item.c);
  });
  
  return Array.from(uniqueCategories);
}

function scaleProperties(color_codes, unique_categories){
  let domain = []
  let range = []

  unique_categories.forEach(category_name => {
    domain.push(category_name)
    range.push(color_codes[category_name])
  });

  return {domain: domain, range: range}
}

export function createVegaChart(container_id, labelkey, ajaxResponseData, breakdownAttribute, chartLayout, hidePoint, chartScale, width = "container", height = "container", actions_menu = true, legendTitle = null) {
  let color_hash = {field: 'c', type: "nominal", title: breakdownAttribute}
  
  var graph_spec = {
    width: width,
    height: height,
    autosize: "fit",
    data: { values: ajaxResponseData },
    encoding: {
      x: {field: "x", unitTime: "month", type: "temporal", title: "Time"},
    }
  }

  Rails.ajax({
    type: 'GET',
    url: "/color_codes",
    dataType: 'json',
    success: (response) => {
      let unique_categories = uniqueCategories(ajaxResponseData)

      if(breakdownAttribute == "Platform"){
        let color_codes = response.color_codes.platforms
        color_hash.scale = scaleProperties(color_codes, unique_categories)
      } else {
        let color_codes = response.color_codes.actor_set_attributes[breakdownAttribute]
        if(color_codes) color_hash.scale = scaleProperties(color_codes, unique_categories)
      }

      let chart_data = ajaxResponseData.map(d => ({
        ...d,
        c: d.c.replace(/'/g, "\\'")
      }));
      
      graph_spec.layer = showLayerForMultiTooltipData(labelkey, chart_data, chartLayout, hidePoint, color_hash, chartScale, legendTitle)
      renderGraph(container_id, graph_spec, actions_menu)
    }
  });
}

export function createPieChart(chart_container_class){
  if($(chart_container_class).length > 0) {
    var data_values = eval($(chart_container_class).data("values"));

    if(data_values){
      var yourVlSpec = {
        "$schema": "https://vega.github.io/schema/vega-lite/v5.json",
        "description": "Pie Chart with percentage_tooltip",
        "width": "container",
        "height": "container",
        "autosize": "fit",
        "data": {
          "name": "table",
          "values": data_values,
        },
        "mark": {"type": "arc", "tooltip": true, "innerRadius": 60, "stack": "normalize"},
        "encoding": {
          "theta": {"field": "percentage", "stack": "normalize", "type": "quantitative"},
          "color": {"field": "name", "type": "nominal"}
        }
      };

      renderGraph(chart_container_class, yourVlSpec, false)
    }
  }
  
}

export function createHorizontalBarChart(chart_container_class){
  if($(chart_container_class).length > 0) {
    var data_values = eval($(chart_container_class).data("values"));

    let max = Math.max(...data_values.map(d => d.Mentions))

    if(data_values){
      var yourVlSpec = {
        "$schema": "https://vega.github.io/schema/vega-lite/v5.json",
        "width": "container",
        "height": {"step": 25},
        "data": {"values": data_values},
        "background": "#2B2B2B",
        "encoding": {
          "y": {
            "field": "term",
            "type": "nominal",
            "axis": null,
            "sort": {
              "field": "Mentions",
              "order": "descending"
            }
          }
        },"config": {
          "axis": {
            "domainColor": "white",
            "tickColor": "white",
            "labelColor": "white",
            "titleColor": "white"
          }
        },
        "layer": [{
          "mark": {"type": "bar", "tooltip": true},
          "encoding": {
            "y": {"field": "term", "type": "nominal", "sort": {"field": "Mentions", "order": "descending"}},
            "x":  {"field": "Mentions", "type": "quantitative", "scale": {"domain": [0, max]}, "stack": null},
            "color": {"field": "term", "type": "nominal", "scale": {"scheme": "category10"}, "legend": null}
          }
        }, {
          "mark": {"type": "text", "align": "left", "x": 5, "color": "white"},
          "encoding": {
            "text": {"field": "term"},
          }
        }]
      }


      renderGraph(chart_container_class, yourVlSpec, false)
    }
  }
  
}

export function renderCustomBarChart(container_class, data, dimensions, axis_titles) {
  const container = document.querySelector(container_class);
  if (!container) {
    console.error(`Container ${container_class} not found`);
    return;
  }

  // Read appearance options from data attributes
  const barColorMode = (container.dataset.barColorMode || 'spectrum').toLowerCase();
  const barColor = container.dataset.barColor || '#0f766e';
  const barOrientation = (container.dataset.barOrientation || 'vertical').toLowerCase();

  // Orientation-specific encodings
  const encodings = barOrientation === 'horizontal'
    ? {
        x: { field: 'value', type: 'quantitative', axis: { title: axis_titles.y } },
        y: { field: 'label_name', type: 'nominal', axis: { title: 'Labels' } },
      }
    : {
        x: { field: 'label_name', type: 'nominal', axis: { title: 'Labels', labelAngle: -20 } },
        y: { field: 'value', type: 'quantitative', axis: { title: axis_titles.y } },
      };

  // Color encoding
  const mark = { type: 'bar' };
  const colorEncoding = barColorMode === 'solid'
    ? null
    : { field: 'label_name', type: 'nominal', scale: { scheme: 'category20' }, legend: null };

  if (barColorMode === 'solid') {
    mark.color = barColor;
  }

  const spec = {
    $schema: 'https://vega.github.io/schema/vega-lite/v5.json',
    description: 'Custom Bar Chart by Labels',
    width: dimensions.width,
    height: dimensions.height,
    autosize: 'fit',
    data: { values: data },
    mark,
    encoding: Object.assign(
      {
        tooltip: [
          { field: 'label_name', type: 'nominal', title: 'Label' },
          { field: 'value', type: 'quantitative', title: axis_titles.y }
        ]
      },
      encodings,
      colorEncoding ? { color: colorEncoding } : {}
    )
  };

  renderGraph(container_class, spec, false)
}

export function renderBarChart(container_class, data, axis_titles) {
  const container = document.querySelector(container_class);
  if (!container) {
    console.error(`Container ${container_class} not found`);
    return;
  }
  const spec = {
    $schema: 'https://vega.github.io/schema/vega-lite/v5.json',
    description: 'A simple bar chart',
    data: { values: data },
    mark: {type: 'bar', size: 15, tooltip: true},
    width: "container",
    height: "container",
    encoding: {
      x: {
        field: 'x',
        type: 'temporal',
        timeUnit: 'yearmonthdate',
        axis: { title: axis_titles.x },
        sort: 'ascending'
      },
      y: { field: 'y', type: 'quantitative', axis: { title: axis_titles.y } },
      tooltip: [
        { field: 'x', type: 'temporal', title: axis_titles.x },
        { field: 'y', type: 'quantitative', title: axis_titles.y }
      ]
    }
  };


  renderGraph(container_class, spec, false)
}

export function createDualAxisChart(container_id, seriesData, axisParams = {}) {
  let primaryData = []
  let secondaryData = []
  let primaryMetric = axisParams.primary || null
  let secondaryMetric = axisParams.secondary || null
  
  // Separate and process series data
  seriesData.forEach((series, index) => {
    const data = JSON.parse(series.graphService)
    const labelKey = series.labelKey
    const breakdownAttribute = series.breakdownAttribute
    
    // Determine which axis this series belongs to based on axisAssignment
    const isSecondary = series.axisAssignment === 'secondary'
    
    // Set metrics based on axis params if not already set
    if (!primaryMetric && !isSecondary) primaryMetric = series.searchBy
    if (!secondaryMetric && isSecondary) secondaryMetric = series.searchBy
    
    // Add series identifier and breakdown attribute to data
    const processedData = data.map(d => ({
      ...d,
      series: `${breakdownAttribute}`,
      breakdown_attribute: breakdownAttribute,
      metric_type: labelKey,
      legend_key: `${breakdownAttribute}: ${d.c}`,
      axis_type: isSecondary ? 'secondary' : 'primary'
    }))
    
    if (isSecondary) {
      secondaryData = secondaryData.concat(processedData)
    } else {
      primaryData = primaryData.concat(processedData)
    }
  })
  
  // Combine all data for shared x-axis and tooltip
  const allData = [...primaryData, ...secondaryData]
  
  // Create dual axis specification
  const spec = {
    $schema: "https://vega.github.io/schema/vega-lite/v5.json",
    width: "container",
    height: 400,
    autosize: "fit",
    data: { values: allData },
    encoding: {
      x: { field: "x", type: "temporal", title: "Time" }
    },
    config: {
      tooltip: {
        maxWidth: 1200,
        fontSize: 14
      }
    },
    layer: [
      // Primary axis layer
      {
        transform: [{ filter: "datum.axis_type == 'primary'" }],
        mark: { type: "line", point: true },
        encoding: {
          y: { 
            field: "y", 
            type: "quantitative",
            title: labels[primaryMetric] || primaryMetric,
            scale: { zero: false }
          },
          color: { 
            field: "legend_key", 
            type: "nominal",
            scale: { scheme: "category10" },
            legend: { 
              title: "Chart Series", 
              orient: "right",
              offset: 10
            }
          }
        }
      },
      // Secondary axis layer (only if secondary data exists)
      ...(secondaryData.length > 0 ? [{
        transform: [{ filter: "datum.axis_type == 'secondary'" }],
        mark: { type: "line", point: true, strokeDash: [5, 5] },
        encoding: {
          y: { 
            field: "y", 
            type: "quantitative",
            title: labels[secondaryMetric] || secondaryMetric,
            scale: { zero: false },
            axis: { orient: "right" }
          },
          color: { 
            field: "legend_key", 
            type: "nominal",
            scale: { scheme: "set2" },
            legend: null
          }
        }
      }] : []),
      // Tooltip layer
      {
        transform: [
          { pivot: "legend_key", value: "y", groupby: ["x"] }
        ],
        mark: { type: "rule", strokeWidth: 0 },
        encoding: {
          x: { field: "x", type: "temporal" },
          opacity: { condition: { param: "hover", value: 0.3 }, value: 0 },
          tooltip: [
            { field: "x", type: "temporal", title: "Time", format: "%b %d, %Y %H:%M" },
            ...(() => {
              // Generate tooltip fields for all series dynamically, filtering NaN values
              const tooltipFields = []
              seriesData.forEach((series, index) => {
                const data = JSON.parse(series.graphService)
                const breakdownAttribute = series.breakdownAttribute
                const labelKey = series.labelKey
                const uniqueCategories = [...new Set(data.map(d => d.c))]
                
                uniqueCategories.forEach(category => {
                  const legendKey = `${breakdownAttribute}: ${category}`
                  const metricLabel = labels[labelKey] || labelKey
                  tooltipFields.push({
                    field: legendKey,
                    type: "quantitative",
                    title: `${breakdownAttribute}: ${category} - ${metricLabel}`,
                    format: ".2s"
                  })
                })
              })
              return tooltipFields
            })()
          ]
        },
        params: [{
          name: "hover",
          select: {
            type: "point",
            fields: ["x"],
            nearest: true,
            on: "mouseover",
            clear: "mouseout"
          }
        }]
      }
    ],
    resolve: { 
      scale: { y: "independent" }
    }
  }
  
  renderGraph(container_id, spec, true)
}

function renderGraph(container_id, graph_spec, actions_menu){
  // Add CSS for tooltip styling
  if (!document.getElementById('vega-tooltip-styles')) {
    const style = document.createElement('style');
    style.id = 'vega-tooltip-styles';
    style.textContent = `
      #vg-tooltip-element {
        white-space: nowrap !important;
        max-width: none !important;
        width: max-content !important;
        text-overflow: unset !important;
        overflow: visible !important;
        font-size: 16px !important;
        line-height: 1.4 !important;
      }
      .vg-tooltip {
        white-space: nowrap !important;
        max-width: none !important;
        width: max-content !important;
        text-overflow: unset !important;
        overflow: visible !important;
        font-size: 16px !important;
        line-height: 1.4 !important;
        padding: 12px !important;
      }
      .vg-tooltip table {
        width: max-content !important;
        table-layout: auto !important;
        font-size: 16px !important;
      }
      .vg-tooltip td {
        white-space: nowrap !important;
        text-overflow: unset !important;
        overflow: visible !important;
        max-width: none !important;
        font-size: 16px !important;
        padding: 4px 8px !important;
      }
      .vg-tooltip th {
        font-size: 16px !important;
        padding: 4px 8px !important;
      }
      .vg-tooltip tr {
        display: table-row !important;
      }
    `;
    document.head.appendChild(style);
  }

  vegaEmbed(container_id, graph_spec, { 
    actions: actions_menu,
    tooltip: {
      formatTooltip: (value, valueToHtml) => {
        if (typeof value === 'object' && value !== null) {
          const formatNumber = (num) => {
            // Check for invalid values first, before any operations
            if (num === null || num === undefined || isNaN(num) || !isFinite(num)) {
              return 'No data';
            }
            
            // Convert to number if it's a string
            const numValue = typeof num === 'string' ? parseFloat(num) : num;
            if (isNaN(numValue) || !isFinite(numValue)) {
              return 'No data';
            }
            
            const absNum = Math.abs(numValue);
            if (absNum >= 1000000000) {
              return (numValue / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
            } else if (absNum >= 1000000) {
              return (numValue / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
            } else if (absNum >= 1000) {
              return (numValue / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
            } else {
              return numValue.toString();
            }
          };
          
          const allEntries = Object.entries(value)
            .filter(([key, val]) => key !== 'x')
            .filter(([key, val]) => {
              // Only filter out null, undefined, NaN, and exactly 0
              if (val === null || val === undefined) return false;
              if (typeof val === 'number' && (isNaN(val) || !isFinite(val) || val === 0)) return false;
              if (typeof val === 'string') {
                const numVal = parseFloat(val);
                if (isNaN(numVal) || !isFinite(numVal) || numVal === 0) return false;
              }
              return true;
            })
            .map(([key, val]) => {
              if (typeof val === 'number') {
                return `${key}: ${formatNumber(val)}`;
              }
              return `${key}: ${val}`;
            });
          
          const formatTime = (dateValue) => {
            const date = new Date(dateValue);
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                           'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const month = months[date.getMonth()];
            const day = date.getDate().toString().padStart(2, '0');
            const year = date.getFullYear();
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${month} ${day}, ${year} ${hours}:${minutes}`;
          };
          
          let timeEntry = '';
          if (value.x) {
            timeEntry = `Time: ${formatTime(value.x)}`;
          } else if (value.Time) {
            timeEntry = `Time: ${formatTime(value.Time)}`;
          }
          
          return [timeEntry, ...allEntries].filter(Boolean).join('<br>');
        }
        return valueToHtml(value);
      }
    }
  })
  .then(({spec, view}) => {
    $(container_id).data('vega-view', view);
    getPointData(spec, view);
  }).catch(error => {
    console.error("Vega Embed Error:", error);

    $(container_id).html(`
      <div style="
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: red;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
      ">
        
        <span style="margin-right: 8px; font-size: 25px;">&#9888;</span> 
        Error loading chart. Please contact support.
      </div>
    `);
  });
}